'use server';

import { ai } from '@/ai/genkit';
import { z } from 'genkit';

const DiagnoseCarProblemsInputSchema = z.object({
  symptoms: z.string(),
});
export type DiagnoseCarProblemsInput = z.infer<typeof DiagnoseCarProblemsInputSchema>;

const DiagnoseCarProblemsOutputSchema = z.object({
  diagnosis: z.string(),
  potentialSolutions: z.string(),
});
export type DiagnoseCarProblemsOutput = z.infer<typeof DiagnoseCarProblemsOutputSchema>;

export async function diagnoseCarProblems(input: DiagnoseCarProblemsInput): Promise<DiagnoseCarProblemsOutput> {
  return diagnoseCarProblemsFlow(input);
}

const prompt = ai.definePrompt({
  name: 'diagnoseCarProblemsPrompt',
  input: { schema: DiagnoseCarProblemsInputSchema },
  output: { schema: DiagnoseCarProblemsOutputSchema },
  // Shortened prompt, kept bilingual output so both web and app work
  prompt: `خبير ميكانيكا. الأعراض: {{{symptoms}}}
أعطِ:
1. تشخيص أولي موجز.
2. الحلول المقترحة (2-3 خطوات).
باللغة العربية فقط.`,
  config: { maxOutputTokens: 350 },
});

const diagnoseCarProblemsFlow = ai.defineFlow(
  {
    name: 'diagnoseCarProblemsFlow',
    inputSchema: DiagnoseCarProblemsInputSchema,
    outputSchema: DiagnoseCarProblemsOutputSchema,
  },
  async input => {
    const { output } = await prompt(input);
    return output!;
  }
);
